import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {IdexService} from "../../idex.service";
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {TranslateService} from "@ngx-translate/core";
import {Toast} from "../../shared/toast/toast";
import {MatButton} from "@angular/material/button";
import {pairwise, switchMap, takeUntil} from "rxjs/operators";
import {fromEvent as observableFromEvent} from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-external-signature',
  templateUrl: './external-signature.component.html',
  styleUrls: ['./../register-signature/register-signature.component.css']
})
export class ExternalSignatureComponent implements OnInit {
   public signatureKey: any;
   public fieldType: any;
   colorSelected = 'black';
   sizeSelected = 'normal';
   radius = 5;
   errorMessage = '';
   currentDate: Date;
   error: string;
   imageSignaturePreview: any;
   imageSignatureTemp: any;
   signatureChange = false;
   signatureChangeType = 'original';
   signatureChangeObj: any;
   blobBin: any;
   i: any;
   array: any;
   fileBlob: any;

   colors = [
      {value: 'black', viewValue: 'Black'},
      {value: 'blue', viewValue: 'Blue'}
   ];

   sizes = [
      {value: 'small', viewValue: 'Small'},
      {value: 'normal', viewValue: 'Normal'},
      {value: 'large', viewValue: 'Large'}
   ];

   @ViewChild('canvas', { static: true }) public canvas: ElementRef;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;

   @ViewChild('btnOK', { static: true }) public buttonOK: MatButton;

   // setting a width and height for the canvas
   @Input() public width = 475;
   @Input() public height = 190;

   private cx: CanvasRenderingContext2D;

   constructor(public service: IdexService,
               private dialog: MatDialog,
               private translate: TranslateService,
               private dialogRef: MatDialogRef<ExternalSignatureComponent>,
               public toast: Toast) {
   }

   ngOnInit(): void {

      this.buttonOK.disabled = true;
      // get the context
      const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
      this.cx = canvasEl.getContext('2d');

      // set the width and height
      canvasEl.width = this.width;
      canvasEl.height = this.height;

      // set some default properties about the line
      this.cx.lineCap = 'round';
      this.cx.strokeStyle = '#000';

      this.currentDate = new Date();
      // we'll implement this method to start capturing mouse events
      this.captureEvents(canvasEl);
      this.clearCanvasSignature();
      this.handleGetTranslate('null');
   }

   editDrawCanvas(oldCanvas: HTMLCanvasElement) {
      const canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);
      canvasTmp.width = oldCanvas.width;
      canvasTmp.height = oldCanvas.height;
      ctx.drawImage(oldCanvas, 0, 0);
      return canvasTmp;
   }


   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
   }

   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   private captureEvents(canvasEl: HTMLCanvasElement) {
      observableFromEvent(canvasEl, 'mousedown').pipe(
         switchMap((e) => {
            return observableFromEvent(canvasEl, 'mousemove').pipe(
               // we'll stop (and unsubscribe) once the user releases the mouse
               // this will trigger a 'mouseup' event
               takeUntil(observableFromEvent(canvasEl, 'mouseup')),
               // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
               //  .takeUntil(Observable.fromEvent(canvasEl, 'mouseleave'))
               // pairwise lets us get the previous value to draw a line from
               // the previous point to the current point
               pairwise());
         }))
         .subscribe((res: [MouseEvent, MouseEvent]) => {
            const rect = canvasEl.getBoundingClientRect();

            // previous and current position with the offset
            const prevPos = {
               x: res[0].clientX - rect.left,
               y: res[0].clientY - rect.top
            };

            const currentPos = {
               x: res[1].clientX - rect.left,
               y: res[1].clientY - rect.top
            };

            // this method we'll implement soon to do the actual drawing
            this.drawOnCanvas(prevPos, currentPos);
            // this.imageSignaturePreview = canvasEl.toDataURL();
            const tmp = this.editDrawCanvas(canvasEl);
            this.imageSignaturePreview = tmp.toDataURL();
            this.imageSignatureTemp = canvasEl.toDataURL();
            this.signatureChangeType = 'draw';
            this.signatureChangeObj = canvasEl;
            this.signatureChange = true;

            this.buttonOK.disabled = false;
         });
   }

   private drawOnCanvas(
      prevPos: { x: number, y: number },
      currentPos: { x: number, y: number }
   ) {
      // incase the context is not set
      if (!this.cx) {
         return;
      }

      // start our drawing path
      this.cx.beginPath();

      // we're drawing lines so we need a previous position
      if (prevPos) {
         if (this.sizeSelected === 'small') {
            this.radius = 3;
         } else if (this.sizeSelected === 'normal') {
            this.radius = 5;
         } else if (this.sizeSelected === 'large') {
            this.radius = 8;
         }

         // sets the start point
         this.cx.moveTo(prevPos.x, prevPos.y); // from
         // draws a line from the start pos until the current position
         this.cx.lineTo(currentPos.x, currentPos.y);
         // color
         this.cx.strokeStyle = this.colorSelected; // "#4bf";
         this.cx.lineWidth = this.radius;
         // strokes the current path with the styles we set earlier
         this.cx.stroke();
      }
   }

   clearCanvasSignature() {
      this.cx.clearRect(0, 0, this.width, this.height);
      this.buttonOK.disabled = true;

   }

   uploadSignature(button: any) {
      const typeUpload = this.fieldType === 'signature' ? 'S' : 'I';
      this.blobBin = atob(this.imageSignatureTemp.split(',')[1]);
      this.array = [];
      for (this.i = 0; this.i < this.blobBin.length; this.i++) {
         this.array.push(this.blobBin.charCodeAt(this.i));
      }
      this.fileBlob = new Blob([new Uint8Array(this.array)], {type: 'image/png'});

      button.disabled = true;
      this.service.uploadExtSignature(this.signatureKey, typeUpload, this.fileBlob)
         .subscribe((response) => {
            this.dialogRef.close(true);
            this.toast.success(response);
         }, error => {
            button.disabled = false;
         });
   }

   handleGetTranslate(key) {
      this.translate.get(key).subscribe((msg) => {
         this.errorMessage = msg;
      });
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   closeDialog() {
      this.dialogRef.close(false);
   }
}
